export default __webpack_public_path__ + "static/hifimap2-22cd071e5527efc7be8e7348bb77e7b2.png";